import { isLoggedIn, logOut, getUserEmail } from "./components/utils/auth";
export default {

    state: {
        isLoggedIn: false,
        userEmail:null,
        user: {},
        categories:[],
        usersList:[],
        filteredUsersList: [],
        message:null,
        success:false,
        error: false,
        useProducts: false,
        useAdmin: true,
        useLocale: false,
        icons:[],
        priceDeviationAdmins: [ // DO NOT MODIFY UNLESS DIRECTED TO. WILL GIVE USER ADMIN PRIVILEGES BEYOND BASIC ACCESS
            30, // Jeff Schwoeppe
            68, // Kyle Lekkas
            93, // Julia Joedicke
            21196, // Lisa Singh
            21201, // Cory Dinon
            21212, // Ricky Meyers
            21246, // Kevin Box
            21247, // Dan Taft
            21248, // Carl Frederick
            21362, // Scott O'Malley
            21366, // Martiza Castillo
            21367, // Hector Rocha
        ],
        priceERPAdmins: [ // DO NOT MODIFY UNLESS DIRECTED TO. WILL GIVE USER ADMIN PRIVILEGES BEYOND BASIC ACCESS
            30, // Jeff Schwoeppe
            68, // Kyle Lekkas
            93, // Julia Joedicke
            21196, // Lisa Singh
            21201, // Cory Dinon
            21212, // Ricky Meyers
            21246, // Kevin Box
            21247, // Dan Taft
            21362, // Scott O'Malley
            21366, // Martiza Castillo
            21367, // Hector Rocha
        ],
    },
    mutations: {
        setUser(state,payload){
            state.user=payload;
        },
        setUsersList(state,payload){
            state.usersList=payload;
        },
        setFilteredUsersList(state,payload){
            state.filteredUsersList=payload;
        },
        setLoggedIn(state,payload){
            state.isLoggedIn=payload;
        },
        setUserEmail(state,payload){
            state.userEmail=payload;
        },
        loadCategories(state, payload) {
            state.categories = payload;
        },
        loadIcons(state, payload) {
            state.icons = payload;
        },

    },
    getters:{
        getUser:state=>{
            return state.user;
        },

    },
    actions: {
        async loadStoredState({commit, dispatch}){
            commit("setLoggedIn", isLoggedIn());
            commit("setUserEmail", getUserEmail());

            // loading user detail if the user is logged in
            if(isLoggedIn()){
                try {
                    const user= (await axios.get('/user')).data;
                    localStorage.setItem("approved", user.approved);
                    localStorage.setItem("userType", user.user_group_id);

                } catch (error) {
                    dispatch("logout");
                }
            }
        },
        async loadUser({commit, dispatch}){
            if(isLoggedIn()){
                try {
                    const user= (await axios.get('/user')).data;
                    commit("setUserEmail", user.email);
                    commit("setUser", user);
                    commit("setLoggedIn", true);


                } catch (error) {
                    dispatch("logout");
                }
            }
        },
        logout({commit}){
            commit("setUser", {});
            commit("setLoggedIn", false);
            commit("setUserEmail", null);
            logOut();
        },
        loadIcons({commit,state}){
            axios.get(`/api/productIcons`).then((response)=>{
                commit('loadIcons',  response.data);
            })

        },
    },
};
